<template>
  <div>
    <gat-form>
      <v-btn small @click="addNewRule()" :disabled="editRowId > 0"
      >Add rule</v-btn
    >
    <v-btn small @click="cancelEdit()" :disabled="!editRowId">Cancel</v-btn>
      <GatGrid title="Rules" :items="$store.state.rules" :columns="columns">
        <template slot="cell" slot-scope="cellProps">
          <span class="btnCol" v-if="cellProps.column.field === 'BTNS'">
            <v-btn
              flat
              icon
              small
              color="blue"
              @click="setEditRow(cellProps.row)"
              :disabled="editRowId > 0"
              v-show="editRowId != cellProps.row.RULE_ID"
            >
              edit
            </v-btn>
            <v-btn
              flat
              icon
              small
              @click="duplicateEditRow(cellProps.row)"
              :disabled="editRowId > 0"
              v-show="editRowId != cellProps.row.RULE_ID"
            >
              dupl
            </v-btn>
            <v-btn
              flat
              small
              color="green"
              @click="saveRule()"
              v-show="editRowId === cellProps.row.RULE_ID"
            >
              save
            </v-btn>
          </span>

          <div v-else-if="cellProps.column.field === 'RULE_NAME'">
            <span v-show="editRowId === cellProps.row.RULE_ID">
              <gat-edit
                label="Name"
                dense
                size="xs12"
                :noflex="true"
                v-model="editRow.RULE_NAME"
              />
            </span>
            <span v-show="editRowId !== cellProps.row.RULE_ID">
              {{ cellProps.row.RULE_NAME }}
            </span>
          </div>

          <div v-else-if="cellProps.column.field === 'RULE_CAT_ID'">
            <span v-show="editRowId === cellProps.row.RULE_ID">
              <category-select v-model="editRow.RULE_CAT_ID" />
            </span>
            <span v-show="editRowId !== cellProps.row.RULE_ID">
              {{ getCatName(cellProps.row.RULE_CAT_ID) }}
            </span>
          </div>

          <div v-else-if="cellProps.column.field === 'RULE_MATCH_TEXT'">
            <span v-show="editRowId === cellProps.row.RULE_ID">
              <gat-edit
                label="Text"
                dense
                size="xs12"
                :noflex="true"
                v-model="editRow.RULE_MATCH_TEXT"
              />
            </span>
            <span v-show="editRowId !== cellProps.row.RULE_ID">
              {{ cellProps.row.RULE_MATCH_TEXT }}
            </span>
          </div>

          <div v-else-if="cellProps.column.field === 'RULE_MATCH_TYPE'">
            <span v-show="editRowId === cellProps.row.RULE_ID">
              <gat-edit
                label="Type"
                dense
                size="xs12"
                :noflex="true"
                v-model="editRow.RULE_MATCH_TYPE"
              />
            </span>
            <span v-show="editRowId !== cellProps.row.RULE_ID">
              {{ cellProps.row.RULE_MATCH_TYPE }}
            </span>
          </div>

          <div v-else-if="cellProps.column.field === 'RULE_MATCH_ACCOUNT'">
            <span v-show="editRowId === cellProps.row.RULE_ID">
              <gat-edit
                label="Account"
                dense
                size="xs12"
                :noflex="true"
                v-model="editRow.RULE_MATCH_ACCOUNT"
              />
            </span>
            <span v-show="editRowId !== cellProps.row.RULE_ID">
              {{ cellProps.row.RULE_MATCH_ACCOUNT }}
            </span>
          </div>

          <div v-else-if="cellProps.column.field === 'RULE_MATCH_AMOUNT'">
            <span v-show="editRowId === cellProps.row.RULE_ID">
              <gat-edit
                label="Amount"
                dense
                size="xs12"
                :noflex="true"
                v-model="editRow.RULE_MATCH_AMOUNT"
              />
            </span>
            <span v-show="editRowId !== cellProps.row.RULE_ID">
              {{ cellProps.row.RULE_MATCH_AMOUNT }}
            </span>
          </div>
        </template>
      </GatGrid>
    </gat-form>
    
  </div>
</template>

<script>
import GatGrid from "@/GatComponents/GatGrid.vue";

import GatUtils from "@/GatComponents/GatUtils";
import GatEdit from "@/GatComponents/GatEdit.vue";
import GatForm from "@/GatComponents/GatForm.vue";
import CategorySelect from "../components/CategorySelect.vue";
import { apiPost } from "@/dal.js";
export default {
  name: "Rules",
  props: [],
  components: { GatGrid, GatEdit, GatForm, CategorySelect },
  data: function () {
    return {
      editRowId: null,
      editRow: {
        RULE_ID: null,
        RULE_NAME: null,
        RULE_CAT_ID: null,
        RULE_MATCH_REF: null,
        RULE_MATCH_TYPE: null,
        RULE_MATCH_TEXT: "TIBBER",
        RULE_MATCH_AMOUNT: null,
        RULE_MATCH_ACCOUNT: null,
        RULE_SORT: null,
      },
    };
  },

  created() {},

  computed: {
    columns() {
      return [
        { header: " ", field: "BTNS", width: "400" },
        //{header:"Name",field:"RULE_NAME"},
        {
          header: "Target",
          field: "RULE_CAT_ID",
          calculated: (rowData) => {
            return GatUtils.lookupCode(
              rowData.RULE_CAT_ID,
              this.$store.state.categories,
              "CAT_ID",
              "fullName"
            );
          },
        },
        { header: "Match text", field: "RULE_MATCH_TEXT" },
        { header: "Match type", field: "RULE_MATCH_TYPE" },
        { header: "Match account", field: "RULE_MATCH_ACCOUNT" },
        { header: "Match amount", field: "RULE_MATCH_AMOUNT" },
        { header: "Match ref", field: "RULE_MATCH_REF" },
        { header: "Sort", field: "RULE_SORT" },
      ];
    },
  },

  mounted() {},

  watch: {},

  methods: {
    addNewRule() {
      let newRule = this.copyRuleItem({ RULE_ID: 99999 });

      this.$store.commit("addRule", newRule);
      this.editRow = newRule;
      this.editRowId = 99999;
    },

    cancelEdit() {
      if (this.editRow.RULE_ID === 99999) {
        this.$store.commit("removeRule", this.editRow);
      }
      this.editRowId = null;
    },

    copyRuleItem(ruleItem) {
      let result = {
        RULE_ID: ruleItem.RULE_ID,
        RULE_NAME: ruleItem.RULE_NAME,
        RULE_MATCH_TEXT: ruleItem.RULE_MATCH_TEXT,
        RULE_MATCH_REF: ruleItem.RULE_MATCH_REF,
        RULE_MATCH_AMOUNT: ruleItem.RULE_MATCH_AMOUNT,
        RULE_MATCH_ACCOUNT: ruleItem.RULE_MATCH_ACCOUNT,
        RULE_MATCH_TYPE: ruleItem.RULE_MATCH_TYPE,
        RULE_SORT: ruleItem.RULE_SORT,
        RULE_CAT_ID: ruleItem.RULE_CAT_ID,
      };
      return result;
    },

    duplicateEditRow(rowItem) {
      let newRule = this.copyRuleItem(rowItem);
      newRule.RULE_ID = 99999;
      this.$store.commit("addRule", newRule);
      this.editRow = newRule;
      this.editRowId = 99999;
    },

    getCatName(catId) {
      return GatUtils.lookupCode(
        catId,
        this.$store.state.categories,
        "CAT_ID",
        "fullName"
      );
    },

    saveRule() {
      //new rule
      apiPost("rule", this.editRow).then((result) => {
        if (result.id) {
          if (this.editRow.RULE_ID === 99999) {
            this.$store.commit("reomveRule", this.editRow);
            this.editRow.RULE_ID = result.id;
            this.$store.commit("addRule", this.copyRuleItem(this.editRow));
          } else {
            this.$store.commit("updateRule", this.copyRuleItem(this.editRow));
          }
          this.cancelEdit();
        }
      });
    },

    setEditRow(rowData) {
      this.editRow = this.copyRuleItem(rowData);
      //console.log(rowData)            ;
      this.editRowId = rowData.RULE_ID;
    },
  },
};
</script>

<style scoped></style>
